import { defineComponent as _defineComponent } from 'vue'
import { useVModel } from '@vueuse/core';
import { ref } from 'vue';

import { type DefaultModalDialogApi, useModalDialogApi } from './bootstrap-modal';
import BootstrapModal from './bootstrap-modal.vue';
import type { ConfirmationDialogApi } from './confirmation-dialog';


export default /*#__PURE__*/_defineComponent({
  __name: 'confirmation-dialog',
  props: {
    modelValue: { type: Boolean },
    message: null,
    cancel: { type: Boolean }
  },
  emits: ["update:modelValue", "update:message", "update:cancel", "after-submit"],
  setup(__props: any, { expose, emit }: { emit: ({
    (event: 'update:modelValue', value: boolean | undefined): void;
    (event: 'update:message', value: string | undefined): void;
    (event: 'update:cancel', value: boolean | undefined): void;
    (event: 'after-submit', value: undefined): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    modelValue?: boolean;
    message?: string;
    cancel?: boolean;
}


//eslint-disable-next-line no-spaced-func

const showDialog = useVModel(props, 'modelValue', emit, { passive: true });
const _message = useVModel(props, 'message', emit, { passive: true });
const _cancel = useVModel(props, 'cancel', emit, { passive: true });
const modalApi = ref<DefaultModalDialogApi | undefined>();

const confirmApi: ConfirmationDialogApi = useModalDialogApi({
    api: modalApi,
    onBeforeShow(args) {
        _message.value = args?.message;
        _cancel.value = args?.cancel;
    },
});
expose(confirmApi);


return { __sfc: true,props, emit, showDialog, _message, _cancel, modalApi, confirmApi, BootstrapModal }
}

})